/**
 * 文件说明:
 *
 * crm request
 *
 * ----------------------------------------
 * 创建用户: leo
 */

import request from 'utils/request'

export default request
